import { css } from 'styled-components';
import { SpacingName } from '../../theme/constants';
import { TypographyName } from '../../theme/typography';
import { getTypography, getSpacing } from '../../theme/utils';
export const title = _ref => {
  let {
    theme
  } = _ref;
  return css(["", ""], getTypography(theme, TypographyName.H3));
};
export const description = _ref2 => {
  let {
    theme
  } = _ref2;
  return css(["", " ", ""], getTypography(theme, TypographyName.BODY), getSpacing.marginTop(theme, SpacingName.SMALL));
};
export const footer = _ref3 => {
  let {
    theme
  } = _ref3;
  return css(["", " ", " border-top:1px solid ", ";"], getSpacing.marginTop(theme, SpacingName.MEDIUM), getSpacing.paddingTop(theme, SpacingName.SMALL), theme.palettes.neutrals.light);
};
//# sourceMappingURL=ConfirmBox.style.js.map